import { AGENT_FORM_FIELDS, AGENT_FORM_FIELDS_NAMES } from './new-agent-form';
import { IFormInputProps } from '../../components/merchants/FormInput';
import { InputType } from '../../components/form/form-input-constants';

export const NEW_AGENT_INFORMATION_INPUTS = ({ t, emailAdditionalClasses, agent }): IFormInputProps[] => ([
	{
		key: AGENT_FORM_FIELDS.FIRST_NAME,
		fieldName: AGENT_FORM_FIELDS.FIRST_NAME,
		placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(AGENT_FORM_FIELDS_NAMES.FIRST_NAME)}`,
		label: t(AGENT_FORM_FIELDS_NAMES.FIRST_NAME),
		inputType: InputType.Text,
		required: true,
		additionalClasses: 'col-sm-12 col-md-12',
		autoComplete: 'off'
	},
	{
		key: AGENT_FORM_FIELDS.LAST_NAME,
		fieldName: AGENT_FORM_FIELDS.LAST_NAME,
		placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(AGENT_FORM_FIELDS_NAMES.LAST_NAME)}`,
		label: t(AGENT_FORM_FIELDS_NAMES.LAST_NAME),
		inputType: InputType.Text,
		required: true,
		additionalClasses: 'col-sm-12 col-md-12',
		autoComplete: 'off'
	},
	{
		key: AGENT_FORM_FIELDS.EMAIL,
		fieldName: AGENT_FORM_FIELDS.EMAIL,
		placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(AGENT_FORM_FIELDS_NAMES.EMAIL)}`,
		label: t(AGENT_FORM_FIELDS_NAMES.EMAIL),
		inputType: InputType.Text,
		required: true,
		additionalClasses: emailAdditionalClasses(),
		readOnly: agent?.id && true,
		disabled: agent?.id && true,
		autoComplete: 'off'
	},{
		key: AGENT_FORM_FIELDS.PHONE,
		fieldName: AGENT_FORM_FIELDS.PHONE,
		placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(AGENT_FORM_FIELDS_NAMES.PHONE)}`,
		label: t(AGENT_FORM_FIELDS_NAMES.PHONE),
		inputType: InputType.Phone,
		defaultCountry: 'US',
		required: true,
		additionalClasses: 'col-sm-12 col-md-12',
		autoComplete: 'off'
	},
]);
